// extracted by mini-css-extract-plugin
export default {"header":"Header_header__QJfsy","container":"Header_container__Pv0TG"};